import { connect } from 'react-redux';
import { fetchDriverProperties } from '../../../../../../actions';
import { Card, Dropdown } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import PropertyCheckboxArray from './components/PropertyCheckboxArray';
import PropertyPickerArray from './components/PropertyPickerArray';
import { Trans } from 'react-i18next';

class DaliAddressing extends BaseFeature {

    constructor(props) {
        super(props);
        this.state = {
            isEnabled: this.props.properties["dadr.en"].value === "1",
            address: this.props.properties["dadr.adr"].value,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeAddress = this.handleChangeAddress.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        if (propertyName.startsWith('dadr.en')) {
            this.setState({ isEnabled: value === "1" ? true : false })
        }
        this.props.handleChange(propertyName, v);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.properties["dadr.en"].value !== prevProps.properties["dadr.en"].value) {
            this.setState({ isEnabled: this.props.properties["dadr.en"].value === "1" });
        }
        if (this.props.properties["dadr.adr"].value !== prevProps.properties["dadr.adr"].value) {
            this.setState({ address: this.props.properties["dadr.adr"].value });
        }
    }

    handleChangeAddress(e) {
        const v = e.target.name;
        this.setState({ address: v });
        this.props.handleChange('dadr.adr', v);
    }

    render() {
        const dadrEnableProperty = this.props.properties["dadr.en"];
        const dadrAddressProperty = this.props.properties["dadr.adr"];
        const dadrGroupProperty = this.props.properties["dadr.grp"];
        const dadrScenesProperty = this.props.properties["dadr.sz"];
        return (
            <div className="flex-row">
                {Object.keys(dadrEnableProperty).length > 0 &&
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Dali_Addressing" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={dadrEnableProperty}
                                title={dadrEnableProperty.info.displayName}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                }
                {Object.keys(dadrAddressProperty).length > 0 &&
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Address" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <Dropdown>
                                <Dropdown.Toggle disabled={!this.state.isEnabled} variant="secondary" className="edit-icon-project-header dropdown-osram">{this.state.address}</Dropdown.Toggle>
                                <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                    {dadrAddressProperty.valueMeta.availableValues.map((element) => {
                                        return <Dropdown.Item onClick={this.handleChangeAddress} name={element} key={element} >{element}</Dropdown.Item>
                                    })}

                                </Dropdown.Menu>
                            </Dropdown>
                        </Card.Body>
                    </Card>
                }
                {Object.keys(dadrGroupProperty).length > 0 &&
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Groups" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyCheckboxArray
                                property={dadrGroupProperty}
                                arrayLength={16}
                                disabled={!this.state.isEnabled}
                                handleChange={this.handleChange}
                            />
                        </Card.Body>
                    </Card>
                }
                {Object.keys(dadrScenesProperty).length > 0 &&
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Scenes" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyPickerArray
                                property={dadrScenesProperty}
                                arrayLength={16}
                                disabled={!this.state.isEnabled}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
    fetchDriverProperties
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DaliAddressing);
